export default "__VITE_ASSET__83a91597__"